<template>
  <div class="category">
    <category-dialog ref="categoryDialog" @submitted="updateData" />
    <div class="filter">
      <el-form inline class="control-bar">
        <div class="right-button">
          <el-button size="mini" type="success" @click="showDialog('create')" :disabled="isSort">新規追加</el-button>
        </div>
        <div class="right-button" v-show="!isSort">
          <el-button size="mini" type="primary" @click="switchSortMode()" icon="el-icon-sort">並べ替え</el-button>
        </div>
        <div class="right-button" v-show="isSort">
          <el-button size="mini" type="success" @click="updateSort()" icon="el-icon-check">更新</el-button>
          <el-button size="mini" type="danger" @click="cancelSort()">キャンセル</el-button>
        </div>
      </el-form>
    </div>
    <div class="content-list" v-if="showTable">
      <el-table
        :data="screenData"
        :row-class-name="getRowClass"
        @row-dblclick="rowDbClick"
        ref="dataTable"
        class="sortable"
        height="100%"
        style="width: 100%">
        <el-table-column
          prop="listOrder"
          class-name="order-col"
          label="並び順"
          header-align="center"
          align="center">
        </el-table-column>
        <el-table-column
          prop="code"
          label="コード">
        </el-table-column>
        <el-table-column
          prop="name"
          label="カテゴリー名称"
          header-align="center"
          align="left">
          <template slot-scope="scope">
            <span :class="scope.row.isActive === false ? 'inactive' : ''">
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="departmentName"
          class-name="column-name"
          label="部門名"
          header-align="center"
          align="left">
          <template slot-scope="scope">
            <span :class="scope.row.departmentIsActive === false ? 'inactive' : ''">
              {{ scope.row.departmentName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          align="center">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="showDialog('edit', scope.row)"
              size="mini"
              type="success"
              :disabled="isSort">編集
            </el-button>
            <el-button
              @click.native.prevent="deleteCategory(scope.row.pk)"
              size="mini"
              type="danger"
              :disabled="isSort">削除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import CategoryDialog from './Dialog'
import Sortable from 'sortablejs'
import {mapGetters} from 'vuex'

export default {
  name: 'CategorySetting',
  components: {
    CategoryDialog,
  },
  data () {
    return {
      orgData: [],
      departmentData: [],
      departmentDict: {},
      isShowDialog: false,
      formLabelWidth: '120px',
      sortArray: [],
      sortable: {},
      isSort: false,
      showTable: true,
    }
  },
  computed: {
    ...mapGetters('account', [
      'isGroupMode',
      'asShop',
    ]),
    screenData: function () {
      let result = []
      if (this.orgData) {
        for (let category of this.orgData) {
          if (category.departmentSlug) {
            let department = this.departmentDict[category.departmentSlug]
            if (department) {
              category.departmentName = department.name
              category.departmentIsActive = department.isActive
            }
            if (!department || !category.departmentIsActive) {
              category.departmentSlug = null
            }
          }
          result.push(category)
        }
      }
      return result
    },
  },
  watch: {
    isGroupMode (val) {
      if (val) {
        this.$router.push({name: 'Home'})
      }
    },
    asShop (val) {
      if (val) {
        this.fetchData()
      }
    },
  },
  methods: {
    fetchData () {
      this.orgData = []
      this.departmentData = []
      this.isLoading = true
      this.$request.categories.getCategories().then(res => {
        let result = res.body
        if (result.departmentList) {
          for (let dept of result.departmentList) {
            this.departmentData.push(dept)
            this.departmentDict[dept.slug] = dept
          }
        }
        if (result.categoryList.results) {
          this.orgData.push(...result.categoryList.results)
        }
        console.log(res)
      }, err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
      })
    },
    updateData ([mode, data]) {
      if (!data) {
        return
      }
      switch (mode) {
        case 'add':
          this.orgData.push(data)
          break
        case 'edit':
          let index = this.orgData.findIndex(x => x.pk === data.pk)
          this.orgData.splice(index, 1)
          this.orgData.splice(index, 0, data)
          break
      }
    },
    getRowClass ({row, rowIndex}) {
      return rowIndex
    },
    showDialog (mode, data) {
      switch (mode) {
        case 'create':
          const listOrder = this.orgData.length ? Math.max.apply(null, this.orgData.map(x => x.listOrder), [this.orgData.length]) : 0
          this.$refs.categoryDialog.show(true, {listOrder: listOrder + 1}, this.departmentData)
          break
        case 'edit':
          this.$refs.categoryDialog.show(false, data, this.departmentData)
          break
        default:
          break
      }
      this.isShowDialog = true
    },
    rowDbClick (row) {
      this.showDialog('edit', row)
    },
    deleteCategory (pk) {
      this.$confirm('カテゴリーの削除をしてもよろしいですか？', '', {
        confirmButtonText: 'OK',
        cancelButtonText: 'キャンセル',
        type: 'warning',
      }).then(() => {
        this.isLoading = true
        this.$request.categories.deleteCategory(pk).then(res => {
          let index = this.orgData.findIndex(x => x.pk === pk)
          this.orgData.splice(index, 1)
          this.$message({
            message: '削除しました。',
          })
          console.log(res)
        }, err => {
          const body = err.response.body
          this.$parent.$emit('requestError', [body])
          console.log(err)
        }).finally(() => {
          this.isLoading = false
        })
      }).catch(() => {
      })
    },
    switchSortMode () {
      this.isSort = true
      this.sortArray = this.screenData.map(x => ({'pk': x.pk, 'listOrder': x.listOrder}))
      // init sort status array
      let table = $(this.$refs.dataTable.$el).find('tbody')[0]
      let self = this
      this.sortable = Sortable.create(table, {
        dataIdAttr: 'class',
        animation: 150,
        scroll: true,
        scrollSensitivity: 30,
        scrollSpeed: 10,
        onUpdate (evt) {
          let el = self.sortArray.splice(evt.oldIndex, 1)
          self.sortArray.splice(evt.newIndex, 0, el[0])
        },
      })
    },
    updateSort () {
      // get list update
      let updateArray = []
      for (let index = 0; index < this.sortArray.length; index++) {
        if (index !== this.sortArray[index].listOrder - 1) {
          updateArray.push({
            pk: this.sortArray[index].pk,
            listOrder: index + 1,
          })
        }
      }

      if (updateArray.length < 1) {
        this.cancelSort()
        return
      }
      // update
      this.$request.categories.updateListOrder(updateArray).then(res => {
        // update list
        let categories = res.body
        if (categories) {
          for (let category of categories) {
            this.updateData(['edit', category])
          }
          this.$nextTick(() => {
            this.orgData.sort((a, b) => a.listOrder - b.listOrder)
          })
        }

        this.$message({
          message: '更新しました。',
        })
        this.isShowDialog = false
        console.log(res)
        return 0
      }, err => {
        const body = err.response.body
        this.$parent.$emit('requestError', [body])
        console.log(err)
      }).finally(() => {
        this.cancelSort()
        this.isLoading = false
      })
    },
    cancelSort () {
      this.isSort = false
      this.refreshTable()
      this.sortable.destroy()
    },
    refreshTable () {
      this.showTable = false
      this.$nextTick(() => {
        this.showTable = true
      })
    },
  },
  mounted () {
    this.fetchData()
  },
}
</script>

<style lang="sass">
@import "static/sass/variables.sass"
@import "static/sass/report/common.sass"

.inactive
  color: $placeholder-color
.inactive::after
  color: $error-color
  content: "[一時停止]"
</style>

<style lang="sass" scoped>
@import "static/sass/variables.sass"

.category
  height: calc( 100% - 15px )

.content-list
  height: 100%

.el-input,
.el-select
  width: 300px

.control-bar
  padding-left: 20px
  div
    float: right
    padding-right: 20px

</style>



// WEBPACK FOOTER //
// src/components/Category/Index.vue